import { render, staticRenderFns } from "./DisposeCardList.vue?vue&type=template&id=5e2b2e2a&scoped=true"
import script from "./DisposeCardList.vue?vue&type=script&lang=js"
export * from "./DisposeCardList.vue?vue&type=script&lang=js"
import style0 from "./DisposeCardList.vue?vue&type=style&index=0&id=5e2b2e2a&prod&lang=scss"
import style1 from "./DisposeCardList.vue?vue&type=style&index=1&id=5e2b2e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b2e2a",
  null
  
)

export default component.exports